import * as yup from 'yup'
import { shapeSchemaByMetadata } from '@/helpers/field'

export const activitySchema = shapeSchemaByMetadata
export const activity = yup.object().shape({
  categoryId: yup.string().nullable().required(),
})
